import axios from 'axios'

async function start_application(dispatch,data,token,setOpen,setMessage,setRecentQuestion,setHasStarted,setHasEnded,setIndex,setSubmitting){

    setSubmitting(true)

      const startApp = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}start-application/`,data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${token}`
            }
    }).catch(err=>{
        setMessage("connection error,try later")
        setOpen(true)
        setSubmitting(false)
      })

    if (startApp?.status == 200 && startApp?.data.success == true) {
      // console.log(startApp?.data)
    if (startApp?.data?.hasEnded) {
        setHasEnded(true)
        setMessage(startApp?.data?.message)
        setOpen(true)
    } else {
        setRecentQuestion(startApp?.data?.data)
        setHasStarted(true)
        setIndex(startApp?.data?.index)
    }
    setSubmitting(false)

    }else{
      setSubmitting(false)
      setMessage(startApp?.data?.message)
      setOpen(true)
    }

}

export default start_application